module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.visible),
      expression: "visible"
    }],
    staticClass: "plano_modal"
  }, [_c('b-card', [_c('label', [_c('h3', [_vm._v("Extends Modal")])]), _vm._v(" "), _c('b-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "sm": "4"
    }
  }, [_c('label', [_vm._v("Direction:")])]), _vm._v(" "), _c('b-col', {
    attrs: {
      "sm": "8"
    }
  }, [_c('b-form-select', {
    attrs: {
      "options": [{
        value: 'l',
        text: 'left'
      }, {
        value: 'r',
        text: 'right'
      }]
    },
    model: {
      value: (_vm.direction),
      callback: function($$v) {
        _vm.direction = $$v
      },
      expression: "direction"
    }
  })], 1)], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "sm": "4"
    }
  }, [_c('label', [_vm._v("Content Width:")])]), _vm._v(" "), _c('b-col', {
    attrs: {
      "sm": "8"
    }
  }, [_c('NumberInput', {
    model: {
      value: (_vm.contentWidth),
      callback: function($$v) {
        _vm.contentWidth = $$v
      },
      expression: "contentWidth"
    }
  })], 1)], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "sm": "4"
    }
  }, [_c('label', [_vm._v("Content Height:")])]), _vm._v(" "), _c('b-col', {
    attrs: {
      "sm": "8"
    }
  }, [_c('NumberInput', {
    model: {
      value: (_vm.contentHeight),
      callback: function($$v) {
        _vm.contentHeight = $$v
      },
      expression: "contentHeight"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('b-button-toolbar', [_c('b-button', {
    staticStyle: {
      "margin": "5px"
    },
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": function($event) {
        _vm.validate();
      }
    }
  }, [_vm._v("Ok")]), _vm._v(" "), _c('b-button', {
    staticStyle: {
      "margin": "5px"
    },
    on: {
      "click": function($event) {
        _vm.cancel();
      }
    }
  }, [_vm._v("Cancel")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0366393c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/plano/edits/extends_pane.vue
// module id = 2986
// module chunks = 0